// extracted by mini-css-extract-plugin
export default {"dash__loader":"dashboard_dash__loader__XoBDH","dash__loadertext":"dashboard_dash__loadertext__TzxmO","h3_font":"dashboard_h3_font__miUIp"};